<template>
    <app-layout >
        <section class="bg-profile d-table w-100 bg-primary"
                 style="background: url('assets/images/account/bg.png') center center;">
            <div class="container">
                <div class="row mt-5 justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="pages-heading"><h4 class="title text-white mb-0">My Courses </h4></div>
                    </div><!--end col--></div><!--end row-->
            </div><!--end container--></section>

        <section class="section py-3">
            <div class="container">
                <div class="table-responsive bg-white shadow rounded">
                    <table class="table mb-0 table-center">
                        <thead>
                        <tr>
                            <th scope="col" class="border-bottom" colspan="2">Course</th>
                            <th scope="col" class="border-bottom">End at</th>
                            <th scope="col" class="border-bottom">Price</th>
                            <th scope="col" class="border-bottom">Status</th>
                            <th scope="col" class="border-bottom"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr  v-for="subscribe in items.data">
                            <th scope="row" class="text-center">

                                <div class="position-relative mb-2">
                                    <img :src="subscribe.course?.image ?? '/assets/images/contact-detail.jpg'"
                                         class=" rounded" alt="..." width="140">
                                    <div class="overlay rounded-top"></div>
                                </div>

                            </th>
                            <th>

                                <router-link :to="{name: 'courses.show', params: { id: subscribe.course?.id ?? 0 }}"
                                             class="card-title title text-dark">
                                    {{ subscribe.course?.name }}
                                </router-link>

                            </th>
                            <td>
                                {{ subscribe.end_date }}
                            </td>
                            <td>
                                <template v-if="subscribe.amount === 0">
                                    Free
                                </template>
                                <template v-else>
                                    JOD {{ subscribe.amount }}
                                </template>

                            </td>
                            <td>
                                <span class="badge bg-soft-success" v-if="subscribe?.course_status == 'Active' "> {{ subscribe.course_status }} </span>
                                <span class="badge bg-soft-danger" v-else> {{ subscribe.course_status }} </span>
                            </td>
                            <td>
                                <router-link
                                    :to="{name: 'dashboard.home', params: { 'subscribe_id': subscribe.id }}"
                                    class="btn btn-primary" v-if="subscribe?.course_status != 'Expired'">
                                    Continue testing <i class="uil uil-angle-right-b align-middle"></i>
                                </router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <!--                <div class="row justify-content-center">-->
                <!--                    <div class="col-12 text-center">-->
                <!--                        <div class="section-title mb-4 pb-2">-->
                <!--&lt;!&ndash;                            <h4 class="title mb-4">Courses</h4>&ndash;&gt;-->
                <!--                            <p class="text-muted para-desc mx-auto mb-0">-->
                <!--                                Keep track of all your course subscriptions here. Access your ongoing and completed courses, manage your payments, and stay updated with the latest content. Your journey to knowledge is just a click away.-->
                <!--                            </p>-->
                <!--                        </div>-->
                <!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->
                <!--                </div>&lt;!&ndash;end row&ndash;&gt;-->

<!--                <div class="row">-->

<!--                    <div class="col-lg-4 col-md-6 mt-4 pt-2" v-for="subscribe in items.data">-->
<!--                        <div class="card blog blog-primary rounded border-0 shadow">-->
<!--                            <div class="position-relative">-->
<!--                                <img :src="subscribe.course?.image ?? '/assets/images/contact-detail.jpg'"-->
<!--                                     class="card-img-top rounded-top" alt="...">-->
<!--                                <div class="overlay rounded-top"></div>-->
<!--                            </div>-->
<!--                            <div class="card-body content">-->
<!--                                <h5>-->
<!--                                    <router-link :to="{name: 'courses.show', params: { id: subscribe.course?.id ?? 0 }}"-->
<!--                                                 class="card-title title text-dark">-->
<!--                                        {{ subscribe.course?.name }}-->
<!--                                    </router-link>-->
<!--                                </h5>-->
<!--                                <div class="post-meta d-flex justify-content-between mt-3">-->
<!--                                    <ul class="list-unstyled mb-0">-->
<!--                                        &lt;!&ndash;                                        <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)" class="text-muted like">&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                            <i class="uil uil-heart me-1"></i>33</a>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                        <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments">&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                            <i class="uil uil-comment me-1"></i>08</a>&ndash;&gt;-->
<!--                                        &lt;!&ndash;                                        </li>&ndash;&gt;-->
<!--                                        <li class="list-inline-item"><a href="javascript:void(0)"-->
<!--                                                                        class="text-muted comments">-->
<!--                                            <i class="uil ti-stats-up me-1"></i> {{ subscribe.sessions_count }}</a>-->
<!--                                        </li>-->
<!--                                    </ul>-->
<!--                                    <router-link-->
<!--                                        :to="{name: 'questions.courses.filter', params: { 'subscribe_id': subscribe.id }}"-->
<!--                                        class="text-muted readmore">-->
<!--                                        Continue testing <i class="uil uil-angle-right-b align-middle"></i>-->
<!--                                    </router-link>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            &lt;!&ndash;                            <div class="author">&ndash;&gt;-->
<!--                            &lt;!&ndash;                                <small class="user d-block"><i class="uil uil-user"></i> Calvin Carlo</small>&ndash;&gt;-->
<!--                            &lt;!&ndash;                                <small class="date"><i class="uil uil-calendar-alt"></i> 25th June 2021</small>&ndash;&gt;-->
<!--                            &lt;!&ndash;                            </div>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </div>&lt;!&ndash;end col&ndash;&gt;-->

<!--                </div>&lt;!&ndash;end row&ndash;&gt;-->
            </div><!--end container-->
        </section>
    </app-layout>
    <!--    <div>-->
    <!--        <h3 class="text-center">الاشتراكات</h3><br/>-->

    <!--        <form @submit.prevent="getResults">-->
    <!--            -->

    <!--	  <div class="form-group row">-->
    <!--		<label class="col-sm-2 col-form-label">التكلفة</label>-->
    <!--		<div class="col-sm-10">-->
    <!--		  -->
    <!--            <div class="input-group mb-3">-->
    <!--                <span class="input-group-text" id="basic-addon2">from</span>-->
    <!--                <input name="amount[from]" class="form-control" type="number"  v-model="q.amount.from" >-->
    <!--                <span class="input-group-text" id="basic-addon2">to</span>-->
    <!--                <input name="amount[to]" class="form-control" type="number"  v-model="q.amount.to" >-->
    <!--            </div>-->
    <!--            -->
    <!--                		  -->
    <!--		</div>-->
    <!--	  </div>-->

    <!--	  <div class="form-group row">-->
    <!--		<label class="col-sm-2 col-form-label">تاريخ البداية</label>-->
    <!--		<div class="col-sm-10">-->
    <!--		  -->
    <!--            <div class="input-group mb-3">-->
    <!--                <span class="input-group-text" id="basic-addon2">from</span>-->
    <!--                <input name="start_date[from]" class="form-control" type="date"  v-model="q.start_date.from" >-->
    <!--                <span class="input-group-text" id="basic-addon2">to</span>-->
    <!--                <input name="start_date[to]" class="form-control" type="date"  v-model="q.start_date.to" >-->
    <!--            </div>-->
    <!--            -->
    <!--                		  -->
    <!--		</div>-->
    <!--	  </div>-->

    <!--	  <div class="form-group row">-->
    <!--		<label class="col-sm-2 col-form-label">تاريخ الإنتهاء</label>-->
    <!--		<div class="col-sm-10">-->
    <!--		  -->
    <!--            <div class="input-group mb-3">-->
    <!--                <span class="input-group-text" id="basic-addon2">from</span>-->
    <!--                <input name="end_date[from]" class="form-control" type="date"  v-model="q.end_date.from" >-->
    <!--                <span class="input-group-text" id="basic-addon2">to</span>-->
    <!--                <input name="end_date[to]" class="form-control" type="date"  v-model="q.end_date.to" >-->
    <!--            </div>-->
    <!--            -->
    <!--                		  -->
    <!--		</div>-->
    <!--	  </div>-->
    <!-- -->


    <!--            <div class="form-group">-->
    <!--                <button type="submit" class="btn btn-primary">Search </button>-->
    <!--            </div>-->
    <!--        </form>-->

    <!--        <table class="table table-bordered">-->
    <!--            <thead>-->
    <!--            <tr>-->
    <!--                <th>ID</th>-->
    <!--                <td>التكلفة</td>-->
    <!--                <td>المستخدم</td>-->
    <!--                <td>الكورس</td>-->
    <!--                <td>تاريخ البداية</td>-->
    <!--                <td>تاريخ الإنتهاء</td>-->
    <!--            </tr>-->
    <!--            </thead>-->
    <!--            <tbody>-->
    <!--            <tr v-for="item in items?.data" :key="item.id" >-->
    <!--                <td>{{ item.id }}</td>-->
    <!--                <td> {{ item?.amount }}</td>-->
    <!--                <td> {{  item.user?.name }} </td>-->
    <!--                <td> {{  item.course?.name }} </td>-->
    <!--                <td> {{ item?.start_date }}</td>-->
    <!--                <td> {{ item?.end_date }}</td>-->

    <!--                <td>-->
    <!--                    <div class="btn-group" role="group">-->
    <!--                                                                        <router-link :to="{name: 'subscriptions.show', params: { id: item.id }}" class="btn btn-info">show</router-link>-->
    <!--                                                -->
    <!--                                                -->
    <!--                    </div>-->
    <!--                </td>-->
    <!--            </tr>-->
    <!--            </tbody>-->
    <!--        </table>-->
    <!--        <Bootstrap5Pagination-->
    <!--            class="mb-0"-->
    <!--            :data="items"-->
    <!--            :limit="2"-->
    <!--            :show-disabled="false"-->
    <!--            :size="'default'"-->
    <!--            :align="'center'"-->
    <!--            @pagination-change-page="getResults"-->
    <!--        />-->

    <!--    </div>-->
</template>

<script>

import {useToast} from "vue-toastification";
import {Bootstrap5Pagination} from 'laravel-vue-pagination'
import AppLayout from "../../app-layout.vue";
import {useHead} from "@vueuse/head";

const toast = useToast();

export default {
    components: {
        AppLayout,
        Bootstrap5Pagination
    },
    data() {
        return {
            items: [],
            q: this.$route.query,
            form_options: {},
        }
    },
    created() {

        useHead({
            title: 'My Courses',
        })

        this.getResults();
    },
    methods: {
        getResults(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('subscriptions', {
                params: {
                    'page': page,
                    'amount': this.q.amount,
                    'start_date': this.q.start_date,
                    'end_date': this.q.end_date
                }
            }).then(response => {
                toast.dismiss(id);
                this.items = response.data;

                this.$router.replace({
                    name: "subscriptions.index",
                    query: {
                        'page': page,
                        'amount': this.q.amount,
                        'start_date': this.q.start_date,
                        'end_date': this.q.end_date
                    }
                });
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
    }
}
</script>
